import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TransportItem } from '../../../../../models/transport-item.model';
import { OptionsTypeSelector } from '../../../../../models/options-type-selector';
import { TransportFormGroup } from '../../../../../models/forms/TransportFormGroup';
import { HandlingType, LIST_HANDLING_TYPE } from '../../../../../models/handling-type.model';

@Component({
  selector: 'jhi-bary-transport-item-line[item]',
  templateUrl: './bary-transport-item-line.component.html',
  styleUrls: ['./bary-transport-item-line.component.scss'],
})
export class BaryTransportItemLineComponent  {

  @Input() item!: TransportItem;
  @Input() transportFormGroup!: TransportFormGroup;
  @Output() editEvent = new EventEmitter<any>();
  @Output() deleteEvent = new EventEmitter<any>();

  get handlingTypeItem(): HandlingType {
    return LIST_HANDLING_TYPE[this.item.handlingType] || null;
  }

  public getTypology(): OptionsTypeSelector  {
    if (this.transportFormGroup.controls.isControlledTemperature.value) {
      return OptionsTypeSelector.TYPE_CONTROLLED_TEMPERATURE;
    }
    if (this.transportFormGroup.controls.isHazardousMaterial.value) {
      return OptionsTypeSelector.TYPE_HAZARDOUS_MATERIAL;
    }
    return OptionsTypeSelector.TYPE_MARCHANDISES_GENERALES;
  }
}
